import React from 'react'
import PropTypes from 'prop-types'
import SearchInput from '../../ui/SearchInput'

const TOGGLE_ALL_CLASS = 'tw:bg-transparent tw:border-0 tw:cursor-pointer '
  + 'tw:text-sm tw:text-gray-800 tw:flex tw:items-center tw:gap-1 '
  + 'tw:whitespace-nowrap'

const DrawerToolbar = ({ search, onSearchChange, allExpanded, onToggleAll }) => (
  <div className="tw:flex tw:items-center tw:justify-between tw:gap-3">
    <SearchInput
      className="tw:flex-1 tw:max-w-[341px]"
      name="drawer-search"
      placeholder="Rechercher..."
      value={search}
      onChange={onSearchChange}
    />
    <button className={TOGGLE_ALL_CLASS} type="button" onClick={onToggleAll}>
      <span className="tw:underline">{allExpanded ? 'Tout fermer' : 'Tout ouvrir'}</span>
      <i
        aria-hidden="true"
        className={`fas ${allExpanded ? 'fa-chevron-up' : 'fa-chevron-down'} tw:text-base`}
      />
    </button>
  </div>
)

DrawerToolbar.propTypes = {
  allExpanded: PropTypes.bool.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onToggleAll: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired
}

export default DrawerToolbar
